export default "__VITE_ASSET__8e5c601b__"